jQuery( document ).ready( function( $ ) {

	// mobile menu toggle
	$('.mobile-toggle').on('click',function(){
		$(this).toggleClass('toggle-open');
		$(this).find('.fa').toggleClass('fa-bars').toggleClass('fa-times');
		$('nav').slideToggle();
	});

	// When the screen resizes, reset the menu completely so that it always shows on desktop
	$(window).resize(function() {
		if (window.matchMedia('(min-width: 1000px)').matches) {
			$('nav').css('display','');
			$('.mobile-toggle').removeClass('toggle-open');
			$('.mobile-toggle .fa').removeClass('fa-times').addClass('fa-bars');
		}
	});


	$('.gallery-icon a').attr("data-lightbox", 'lightbox');

});